export default "__VITE_ASSET__CiPksy0p__"